import React from 'react';
import IconCell from "../NewCells/IconCell/IconCell";

function PrintModalCell(props) {
    return (
        props?.cellContent?.result == 'unknown'
            ? ""
            : <IconCell
                iconName="printer"
                onClick={
                    _ => props.cellData.onClick(props.idArr[0], props.cellContent[props.cellData.prop1])
                }
            />


    );
}

export default PrintModalCell;